import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { IReckonInRoomCredentials } from '@era/locations-sdk';

export type InRoomCredentialsState = EntityState<IReckonInRoomCredentials>;

export function selectIdFromCredentials(conf: IReckonInRoomCredentials): string {
  return conf.id;
}

export const adapter: EntityAdapter<IReckonInRoomCredentials> = createEntityAdapter<IReckonInRoomCredentials>({
  selectId: selectIdFromCredentials,
});

export const initialState: InRoomCredentialsState = adapter.getInitialState();
